export default __webpack_public_path__ + "static/5-8bc68459adefeb5a804dc02cbe6fd763.png";